const BANNER_KEY = "as_app_banner_snooze_until";
const SHEET_KEY = "as_app_sheet_snooze_until";
const SESSION_COUNT_KEY = "as_mobile_session_count";
const SESSION_MARK_KEY = "as_mobile_session_marked";

export const BANNER_SNOOZE_DAYS = 14;
export const SHEET_SNOOZE_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * App-install promotion policy (see mobile-web-shell design spec):
 * - slim banner for all mobile visitors, dismiss = 14-day snooze
 * - "better in the app" sheet only for RETURNING users (2nd+ boot),
 *   dismiss/"continue on web" = 30-day snooze
 * - never anything interstitial on a first visit
 * Storage and clock are injectable for tests.
 */
export function shouldShowBanner(storage = localStorage, now = Date.now()) {
  const until = Number(storage.getItem(BANNER_KEY) || 0);
  return now >= until;
}

export function snoozeBanner(storage = localStorage, now = Date.now()) {
  storage.setItem(BANNER_KEY, String(now + BANNER_SNOOZE_DAYS * DAY_MS));
}

/**
 * Counts one "session" per app boot (guarded per-tab via sessionStorage so
 * reloads and SPA navigation don't inflate the count).
 */
export function bumpSessionCount(
  storage = localStorage,
  session = sessionStorage,
) {
  if (session.getItem(SESSION_MARK_KEY)) {
    return Number(storage.getItem(SESSION_COUNT_KEY) || 0);
  }
  session.setItem(SESSION_MARK_KEY, "1");
  const n = Number(storage.getItem(SESSION_COUNT_KEY) || 0) + 1;
  storage.setItem(SESSION_COUNT_KEY, String(n));
  return n;
}

export function shouldShowSheet(storage = localStorage, now = Date.now()) {
  const isReturning = Number(storage.getItem(SESSION_COUNT_KEY) || 0) >= 2;
  const until = Number(storage.getItem(SHEET_KEY) || 0);
  return isReturning && now >= until;
}

export function snoozeSheet(storage = localStorage, now = Date.now()) {
  storage.setItem(SHEET_KEY, String(now + SHEET_SNOOZE_DAYS * DAY_MS));
}
